<template>
  <SideNav />

  <header>
    <div
      class="page-header min-vh-50 "
      style="background-image: url('assets/img/castream1.jpeg');"
    >
      <span class="mask bg-black opacity-2" />
    </div>
    <div class="position-relative">
      <div class="container px-md-0 position-relative"> 
        <div class="bg-gradient-info z-index-2 border-radius-xl mt-n7 mt-sm-n9 mt-md-n10  position-relative ">        
          <div class="row align-items-center">
            <img
              src="assets/img/shapes/pattern-lines.svg"
              alt="pattern-lines"
              class="position-absolute opacity-6 start-0 top-0 linebg"
              style="z-index: 10;"
            >         
     
            <div
              class="px-3 ps-md-5 px-lg-5 col-12 col-md-5 col-lg-5  order-2 order-md-1"
              style="z-index: 20;"
            > 
              <div class="text-center text-md-start pb-5 py-md-5 ">
                <div class="position-relative">
                  <h3 class="text-white mt-sm-0 mb-3">
                    CRStream<br class="d-none d-md-block d-lg-none"> 雲端影音串流系統
                  </h3>
                  <p class="text-white mb-3">
                    CRStream standard<br>
                    CRStream Platform<br>
                    <a
                      class="page-link"
                      href="javascript:;"
                      @click="goToPage('CRStreamConvert')"
                    >
                      CRStream Convert
                    </a>
                  </p>


                  <!--
                    @click="goToPage('CRStreamItem')"
                  -->
                  <a
                    href="javascript:;"
                    type="button"
                    class="btn bg-gradient-dark btn-lg me-3 mt-3"
                  ><i class="material-icons me-2">menu_book</i>技術支援</a>                      
                </div>
              </div>
            </div>
            <div
              class="col-10 col-md-7 col-lg-5 col-xl-4 order-1 order-md-2 py-5 mt-n8 mt-md-n7 text-center mx-auto"
              style="z-index: 10;"
            >
              <img
                class="img-fluid"
                src="assets/img/pen.png"
              >
            </div>    
          </div>
        </div> 
      </div>
    </div>
  </header>

  <div class="py-5 pt-lg-6 pb-lg-6 container px-0">
    <div class="p-3 info-hover-warning text-center mb-4 mt-5">
      <div class="icon icon-shape bg-gradient-info shadow icon-shape-circle text-info">
        <i
          class="fa fa-pen  opacity-10"
          aria-hidden="true"
        />
      </div>
    </div>
    <h4 class="mb-4 text-center mb-6">
      Cloud Raise CRStream Standard : <br class="d-md-none">雲端影音串流系統標準版
    </h4>
    <div class="row align-items-center mx-0">
      <div class="d-lg-none">
        <div class="border border-info text-info p-3 rounded mb-4">
          <p>Cloud Raise CRStream Standard 優勢 : </p>
          <ul class="mb-0">
            <li class="mb-3">
              採用SMDN獨家專利技術，提高影音串流服務的效能、品質
            </li>
            <li>SDK開發元件；提供全載具，包含手機、平板、電腦、智能電視皆可播放</li>
          </ul>
        </div>
      </div>
      <div class="mx-auto col-md-6 col-lg-6 order-2 order-md-1">
        <div class="border border-info text-info p-3 rounded mb-4 d-none d-lg-block">
          <p>Cloud Raise CRStream Standard 優勢 : </p>
          <ul class="mb-0">
            <li class="mb-3">
              採用SMDN獨家專利技術，提高影音串流服務的效能、品質
            </li>
            <li>SDK開發元件；提供全載具，包含手機、平板、電腦、智能電視皆可播放</li>
          </ul>
        </div>
        <p class="text-dark lh-lg">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;CRStream standard是一套針對影音串流媒體服務開發與整合所設計的最佳解決方案，其中包含CRStream Converter(影音轉檔工具)和CRStream API。<br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;CRStream Converter(影音轉檔工具)可支援MP3、MP4、AVI、MKV、FLV…等媒體檔案格式，並可設定圖文浮水印防止影音檔案被偽造盜用，也可再透過USB KEY對影音串流媒體加密，以達到保護智財權。
        </p>
      </div>
      <div class="col-10 col-md-6 col-lg-5 col-xxl-4 order-1 order-md-2 mb-5 mb-md-0 mx-auto">
        <img
          src="assets/img/cratream3.jpg"
          class="img-fluid rounded shadow-lg"
        >
      </div>
    </div>

    <section class="pt-5 pt-lg-8">
      <div class="container px-0">
        <div class="row align-items-center mx-0">
          <div class="col-9 col-md-5 col-lg-5 mx-auto">
            <img
              src="assets/img/cratream4.jpg"
              class="img-fluid"
            >
          </div>
          <div class="col-md-7 col-lg-6 mt-lg-0 mt-5 ps-lg-0 ps-0">
            <div class="p-3">
              <p class="text-dark lh-lg ps-3">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;CRStream API支援影音串流媒體的圖文導讀以及同步跟讀功能，並提供全載具（手機、平板、電腦、智能電視）播放及SDK開發元件，搭配系統中的個人管理、系統管理、資源管理、API管理等多樣化的功能，讓使用者可以運用本系統快速建置及擴展高效穩定的影音串流媒體服務。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本產品擁有多項專利以及SMDN（Streaming Media Distribution Network）獨家專利技術，將串流媒體儲存在多個網路資料中心（IDC），可以針對使用者的載具資源、伺服器資源、TCP傳輸，指派較近、較順暢的伺服器節點，將資料傳輸給使用者。自動優化串流媒體服務的播放品質，將效能提升至最佳化，使高頻寬的應用服務（高畫質影片）更加順暢。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>



  <footer class="footer mt-5">
    <div class="container">
      <div class=" row align-items-center">
        <div class="col-md-6 mb-md-4 me-auto">
          <div class="d-none d-md-block">
            <a 
              href="javascript:;"
              @click="goToPage('/')"
            >
              <img
                src="assets/img/logo4.svg"
                class="mb-3"
                style="width: 160px;"
              >
            </a>
          </div>
        </div>

        <div class="col-md-6 mb-md-4 ms-auto text-center text-md-end">
          <a class="mb-3"><img
            src="assets/img/logo4.svg"
            style="width: 160px;"
            class="mb-3 d-md-none"
          ></a>

          <p class="mb-1">
            service@cloudraise.com
          </p>
          <p class="mb-1">
            新北市三重區重新路五段609巷14號5樓之3
          </p>
          <p class="mb-1">
            02-29992891
          </p>
        </div>
        <div class="col-12">
          <div class="text-center">
            <p class="text-dark my-2 my-md-4 text-sm font-weight-normal">
              Copyright ©
              2023
              by Cloud Raise Technology.
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
/* eslint-disable import/no-absolute-path */
// eslint-disable-next-line import/no-unresolved
import { config } from '@/include/config';
import {
  h,
  ref,
  toRefs,
  reactive,
  watch,
  inject,
  onMounted,
  onBeforeUpdate,
  onUpdated
} from 'vue';
import { oltConsole, oAA , oAuth, oApiError , oFrame } from '@/lib/oltModule/initOltVue3';
import { SideNav , Header , ProductHeader , Footer } from '@/components/Frame';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';

export default {
  name: 'App',
  components: {
    SideNav,
    //Header,
    //ProductHeader,
    //NavBar,
    // Settings,
    //Footer,
  },
  setup() {

    /**
     *  swal start
     */
    const swal = inject('$swal');
    /**
     *  swal end
     */

    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    const nid = ref();

    //console.log('router.currentRoute.value : ', router.currentRoute.value.query);
    /*
    if(router.currentRoute.value.query.nid == null || router.currentRoute.value.query.nid == '' ){
      swal.fire({
        icon:'error',
        html:'路徑錯誤！！',
        buttonsStyling: true,
        confirmButtonClass: 'md-button md-success',
        //confirmButtonText:t('messages.confirm_button'),
      }).then( result => {
        if (result.value) {
          //console.log('result : ' , result);
          //emit('addCallBack');
          //router.go(-1);
          goToPage('/');
        }
      });
    }
	*/
    nid.value= router.currentRoute.value.query.nid ; 

    //console.log('nid' , nid.value);

    onMounted(async () => {
      chkLogin();
    });
    // Reload MDInput End

    onUpdated(async () => {
      // 修改 VUE 時 必需全部強制關閉 Modals 
      // eslint-disable-next-line no-undef
      //await oAdminFrame.closeAllModals() ;
    }) ;
    function goToPage(page){
      router.push( { path: page } );
    }


    function chkLogin(){
      let isLogin = oAuth.isLogin(store);

      if(!isLogin){
        //router.push({ path: '/AuthPage/SignIn' });
      }
    }

    return {
      hiddenHeader:false,
      // api setting
      setDebugMode: true,
      apiDebug: false,
      apiName: '',
      perPage: 3, //筆數
      pageMode: true,
      perPageOptions: [5, 10, 25, 50, 75, 100],
      // data
      userInfo:{coin:0 , point:0},
      token:null,
      nid,
      // function
      goToPage,
      chkLogin,
    };
  },
  created() {
  },
  mounted() {
    oFrame.initMD();
  },
  methods: {
  }
};
</script>
<style>

#app .crstreamimg{
    width: 55%;
    margin-bottom: -100px;
}

@media only screen and (max-width: 1400px) {
#app .crstreamimg{
    width: 60%;
    margin-bottom: -100px;
}}
@media only screen and (max-width: 1024px) {
#app .crstreamimg{
    width: 60%;
    margin-bottom: -150px;
}}


</style>
